import http from '@/lib/Http'
import configs from '@/configs'

const path = '/user/concerned'

const fetchInfos = (query) => {
    return http.get(path + '/page', {
        title: query.title || '',
        page: query.page || 0,
        size: query.size || configs.pageSize
    })
}

const fetchSelfInfos = (query) => {
    return http.get(path + '/self', {
        title: query.title || '',
        page: query.page || 0,
        size: query.size || configs.pageSize
    })
}

const findById = (id) => {
    return http.get(path, {params: {id: id}})
}

const save = (info) => {
    return http.post(path, info)
}
const remove = (id) => {
    return http.del(path, {id})
}


export default {
    fetchInfos,
    findById,
    save,
    fetchSelfInfos,
    remove
}